export default "__VITE_ASSET__v$3xqstO__"